var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMethod(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9 14.9996H3.1C1 14.9996 1 14.0546 1 12.8996V12.1996C1 11.8146 1.315 11.4996 1.7 11.4996H14.3C14.685 11.4996 15 11.8146 15 12.1996V12.8996C15 14.0546 15 14.9996 12.9 14.9996ZM14.125 8.69961V11.4996H1.91V8.69961C1.91019 7.21445 2.50024 5.79018 3.55041 4.74002C4.60057 3.68985 6.02484 3.09979 7.51 3.09961H8.525C8.931 3.09961 9.33 3.14161 9.708 3.22561C12.235 3.77161 14.125 6.01161 14.125 8.69961Z",
    stroke: "#189547",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1209 7.3H5.9209M9.7709 2.75C9.7709 2.918 9.7499 3.072 9.7079 3.226C9.3299 3.142 8.9309 3.1 8.5249 3.1H7.5099C7.1039 3.1 6.7119 3.142 6.3339 3.226C6.2919 3.072 6.2709 2.918 6.2709 2.75C6.2709 2.28587 6.45527 1.84075 6.78346 1.51256C7.11165 1.18437 7.55677 1 8.0209 1C8.48503 1 8.93015 1.18437 9.25834 1.51256C9.58652 1.84075 9.7709 2.28587 9.7709 2.75V2.75Z",
    stroke: "#189547",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMethod);
export default __webpack_public_path__ + "static/media/method.b4fbef1ed199fd33a0f740738ce40a0e.svg";
export { ForwardRef as ReactComponent };